import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ProfileTabSection extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array
    ]),
    heading: PropTypes.string
  }

  renderHeading(heading) {
    return heading ?
      (
        <h2 className="player-profile-heading">
          {heading}
        </h2>
      ) : '';
  }

  render() {
    const { children, heading, optionalClasses } = this.props;

    return (
      <div className={`profile-tab-section${optionalClasses ? ' ' + optionalClasses : ''}`}>
        <div className="inner-wrap">
          {this.renderHeading(heading)}
          {children}
        </div>
      </div>
    );
  }
}

export default ProfileTabSection;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileTabSection.js